import React from "react";

const ShareModal = ({ link, onClose }) => {
  const handleShare = (platform) => {
    let url = "";
    switch (platform) {
      case "facebook":
        url = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(link)}`;
        break;
      case "twitter":
        url = `https://twitter.com/intent/tweet?url=${encodeURIComponent(link)}`;
        break;
      case "linkedin":
        url = `https://www.linkedin.com/shareArticle?mini=true&url=${encodeURIComponent(link)}`;
        break;
      default:
        return;
    }
    window.open(url, "_blank");
  };

  return (
    <div className="share-modal">
      <div className="modal-content">
        <button className="close-btn" onClick={onClose}>X</button>
        <h3>Share Course</h3>
        <div className="share-link">
          <input type="text" value={link} readOnly />
        </div>
        <div className="social-buttons">
          <button onClick={() => handleShare("facebook")}>Facebook</button>
          <button onClick={() => handleShare("twitter")}>Twitter</button>
          <button onClick={() => handleShare("linkedin")}>LinkedIn</button>
        </div>
      </div>
    </div>
  );
};

export default ShareModal;
